import en from './en';
import th from './th';

export default {
  en: {
    translation: en,
  },
  th: {
    translation: th,
  },
};



// WEBPACK FOOTER //
// ./src/modules/i18n/resources/index.js